import styles from "../UserAdminModal.module.css";
import PasswordRequirementsChecklist, { isPasswordStrong } from "../PasswordRequirementsChecklist";
import { useUserAdminContext } from "../../context/UserAdminContext";
import { buildImageSrc, getRoleBadgeClass, ROLE_LABELS } from "./userAdminHelpers";
import BrandingSection from "./BrandingSection";

// Extraído de UserAdminModal.jsx (issue 012, docs/07-issues.md) — aba
// "Meu perfil" (dados próprios + marca própria + trocar senha). Comportamento
// idêntico, só mudou de arquivo; estado continua todo em UserAdminModal.jsx,
// consumido via useUserAdminContext().
export default function MyProfileTab() {
  const {
    currentUser,
    apiBase,
    profileForm,
    setProfileForm,
    handleProfileSubmit,
    onProfilePhotoChange,
    saving,
    passwordForm,
    setPasswordForm,
    handlePasswordSubmit,
    isGoogleOnly,
  } = useUserAdminContext();

  return (
    <div className={styles.uamProfileSection}>
      <form className={styles.uamProfileForm} onSubmit={handleProfileSubmit}>
        <div className={styles.uamProfileTop}>
          <div className={`${styles.uamProfileAvatar} ${styles.large}`}>
            {profileForm.preview ? (
              <img src={profileForm.preview} alt={currentUser.name} loading="lazy" referrerPolicy="no-referrer" />
            ) : currentUser.avatar_url ? (
              <img src={buildImageSrc(currentUser.avatar_url, apiBase)} alt={currentUser.name} loading="lazy" referrerPolicy="no-referrer" />
            ) : (
              <span>{currentUser.name?.charAt(0)?.toUpperCase()}</span>
            )}
          </div>

          <div className={styles.uamProfileMeta}>
            <h3>{currentUser.name}</h3>
            <p>{currentUser.email}</p>
            <span className={`${styles.uamBadge} ${getRoleBadgeClass(currentUser.role)}`}>
              {ROLE_LABELS[currentUser.role] || "Usuário"}
            </span>
          </div>

          <span className={styles.uamProfileUpload}>
            <label className={`${styles.uamBtn} ${styles.ghost}`} style={{ cursor: "pointer" }}>
              {profileForm.photo ? "Trocar foto" : "Alterar foto de perfil"}
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => onProfilePhotoChange(e.target.files?.[0])}
              />
            </label>
          </span>
        </div>

        <div className={styles.uamField}>
          <label>Nome</label>
          <input
            type="text"
            value={profileForm.name}
            onChange={(e) =>
              setProfileForm((prev) => ({ ...prev, name: e.target.value }))
            }
            placeholder="Seu nome"
            required
          />
        </div>

        {currentUser.role === "professor" && currentUser.organization_id && currentUser.org_role
          && currentUser.org_role !== "owner" && (
          <div className={styles.uamNote}>
            A marca do app é a da academia, definida pelo dono da academia.
          </div>
        )}

        {currentUser.role === "professor"
          && !(currentUser.organization_id && currentUser.org_role && currentUser.org_role !== "owner") && (
          <BrandingSection
            mode="self"
            owner={currentUser}
            brandColor={profileForm.brand_color}
            onBrandColorChange={(hex) => setProfileForm((f) => ({ ...f, brand_color: hex }))}
            bgColorDark={profileForm.brand_bg_color_dark}
            onBgColorDarkChange={(hex) => setProfileForm((f) => ({ ...f, brand_bg_color_dark: hex }))}
            bgColorLight={profileForm.brand_bg_color_light}
            onBgColorLightChange={(hex) => setProfileForm((f) => ({ ...f, brand_bg_color_light: hex }))}
          />
        )}

        <div className={styles.uamFooter}>
          <button
            type="submit"
            className={`${styles.uamBtn} ${styles.primary}`}
            disabled={saving}
          >
            Salvar perfil
          </button>
        </div>
      </form>

      <form
        className={styles.uamPasswordForm}
        onSubmit={handlePasswordSubmit}
        autoComplete="off"
      >
      <h4 className={styles.uamSectionTitle}>
        {isGoogleOnly ? "Criar senha" : "Alterar senha"}
      </h4>

      {!isGoogleOnly && (
        <div className={styles.uamField}>
          <label>Senha atual</label>
          <input
            type="password"
            name="current_password"
            autoComplete="current-password"
            value={passwordForm.current_password}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                current_password: e.target.value,
              }))
            }
            placeholder="Digite sua senha atual"
            required
          />
        </div>
      )}
      {isGoogleOnly && (
        <div className={styles.uamNote}>
          Você entrou com {currentUser?.auth_provider === "apple" ? "Apple" : "Google"}. Crie uma senha para também poder acessar com email e senha.
        </div>
      )}
        <div className={styles.uamField}>
          <label>Nova senha</label>
          <input
            type="password"
            name="new_password"
            autoComplete="new-password"
            value={passwordForm.new_password}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                new_password: e.target.value,
              }))
            }
            placeholder="Digite a nova senha"
            required
          />
          {passwordForm.new_password && <PasswordRequirementsChecklist password={passwordForm.new_password} />}
        </div>

        <div className={styles.uamField}>
          <label>Confirmar nova senha</label>
          <input
            type="password"
            name="confirm_password"
            autoComplete="new-password"
            value={passwordForm.confirm_password}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                confirm_password: e.target.value,
              }))
            }
            placeholder="Repita a nova senha"
            required
          />
        </div>

        <div className={styles.uamFooter}>
        <button
          type="submit"
          className={`${styles.uamBtn} ${styles.primary}`}
          disabled={saving || !isPasswordStrong(passwordForm.new_password)}
        >
          {isGoogleOnly ? "Criar senha" : "Alterar senha"}
        </button>
        </div>
      </form>
    </div>
  );
}
